module.exports = __webpack_public_path__ + "static/img/pause-bg.d18c8b75.png";